import regeneratorRuntime from "regenerator-runtime";
import 'url-search-params-polyfill';
import Ajaxjs from '../ajax';
import Utilitiesjs from '../utilites';

export default class Accountjs {
    constructor() {
        this.ajaxjs = new Ajaxjs;
        this.utilsjs = new Utilitiesjs;
    }
     
    async login(e, formId, returnUrlId, failedLabelId, rememberMeId, loadingId) {
        e.preventDefault(); 
        const that = this;
        that.utilsjs.showById(loadingId);
        that.setReturnUrl(returnUrlId);
        document.getElementById(rememberMeId).value = document.getElementById(rememberMeId).value === "on" ? true : false;
        if (await this.ajaxjs.serializeAndPostForm(formId, 'LoginAjax', 'account') === '200') {
            window.location.replace(`${window.location.protocol}//${window.location.host}${document.getElementById(returnUrlId).value}`);   
        } else {
            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(failedLabelId);
        }
    }

    setReturnUrl(returnUrlId) {
        const urlParams = new URLSearchParams(window.location.search);
        const returnUrl = urlParams.get('ReturnUrl');
        document.getElementById(returnUrlId).value = returnUrl ? returnUrl : window.location.pathname;
    }

    processFormForgot() {
        if (this.utilsjs.isEmail(document.getElementById("password-email").value)) {
            document.getElementById("return-url-forgot").value = location.pathname;
            document.getElementById("forgot-password-form").submit();
        } else {
            document.getElementById("return-url-forgot").value = location.pathname;
            document.getElementById("forgot-password-validate").innerHTML = " Please enter a valid email";
        }
    };
   
}



// WEBPACK FOOTER //
// ./Scripts/es6/controllers/account.js